<template>
    <div class="ticket">
        <!-- <div class="ticket_img"><img src="../../assets/images/xuebi_24.png"/></div> -->
        <!-- <div class="ticket_img"><img :src="this.weburl + goods_item.original_img"/></div> -->
        <div class="ticket_content">
            <h1>{{goods_item.goods_name}}</h1>
            <p class="ticket_tag">
                <span v-for="(k,i) in getKeyWords(goods_item.keywords)" :key="i">{{k}}</span>
            </p>
            <div class="ticket_book"><!--<span class="add_buy">加入购物车</span>--> <p class="ticket_price"><span
                    class="price_icon">￥</span>{{goods_item.bottom_all_price}}<span class="price_down">起</span>
                <s>￥{{goods_item.market_price}}</s>
            </p><span class="book" @click="booking(goods_item.goods_id)">立即预定</span></div>
        </div>
    </div>
</template>
<script>
    export default {
        name: "ticket",
        props: ["goods_item"],
        mounted: function () {

        },
        computed: {
            weburl: function () {
                return this.$store.state.weburl;
            },
            hurl: function () {
                return this.$store.state.hurl;
            },
        },
        methods: {
            getKeyWords: function (keyWordStr) {
                return keyWordStr.split(" ");
            },
            booking: function (id) {
                // 发送请求获取数据
                // this.$http({
                //     xhrFields: {
                //         withCredentials: true
                //     },
                //     crossDomain: true,
                //     method: "post",
                //     url: this.weburl + this.hurl + "/Goods/reservesInfo",
                //     dataType: "json",
                //     data: {
                //         id: id        //商品id：goods_id
                //     }
                // })
                // .then(res => {
                //     console.log(res.data);
                //     if (res.data.status == 1) {
                //         this.$store.commit("set_goods_details", res.data.result);
                //         this.$router.push({path: '/ticketDetail', query: {goods_id: id}});
                //     }
                // })
                // .catch(err => {
                //     console.log(err);
                // })
                this.$router.push({path: '/ticketDetail', query: {goods_id: id}});
            }
        }
    }
</script>
<style scoped lang="less">
    @import '../../assets/less/common.less';

    .ticket {
        width: 93%;
        // height: 360px;
        .border-radius(10px);
        // margin: 0 20px auto;
        margin: 0 auto 10px;
        background: @font-primary;
        .box-shadow;
    }

    .ticket_img {
        width: @width;
        /*height: 60%;*/
        /*background: yellow;*/
        .border-radius(10px 10px 0 0);
        img {
            .img;
            .border-radius(10px 10px 0 0);
        }
    }

    .ticket_book {
        width: @width;
        height: 45px;
    }

    .ticket_content {
        width: @width;
        /*height: 40%;*/
        .box-sizing;
        padding: @font - .2;
        h1 {
            font-size: @font;
            color: @brick_red;
            margin-bottom: 6px;
        }
    }

    .ticket_tag {
        color: #c9cacd;
        margin-bottom: 5px;
        span {
            margin-right: 5px;
            &:last-child {
                margin-right: 0;
            }
        }
    }

    .ticket_price {
        color: @subject_color;
        font-size: 1.5rem;
        margin-top: 10px;
        margin-bottom: .2rem;
        float: left;
    }

    .price_icon {
        float: left;
        margin-top: 3px;
    }

    .price_icon, .price_down, s, .ticket_tag {
        font-size: .6rem;
    }

    s {
        color: #c9cacd;
        margin-left: 5px;
    }

    /*.add_buy,*/
    .book {
        display: inline-block;
        padding: 5px;
        height: 30px;
        line-height: 30px;
        .border-radius(10px);
        color: #fff;
        font-size: @font;
        text-align: center;
    }

    /* .add_buy {
         padding-left: 20px;
         width: 100px;
         background:@brick_red;
    } */
    .book {
        float: right;
        width: 86px;
        background: @subject_color;
        margin-top: .2rem;
    }
    @media (min-width: 768px) {
        .ticket_content {
            padding: @font - .2;
            h1 {
                font-size: @font + .2;
                margin-bottom: 10px;
            }
        }
        .price_icon, .price_down, s, .ticket_tag {
            font-size: .9rem;
        }

        .ticket_price {
            font-size: 1.9rem;
        }

    }
</style>
